import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export const REQUIRED_WHEN_ERROR = "requiredWhen";

/**
 * Group-level validator: when the boolean control `toggleControlName` is checked,
 * every control in `requiredControlNames` must hold a non-blank value.
 * On failure, returns `{ requiredWhen: string[] }` listing the missing control names.
 */
export function requiredWhenValidator(
  toggleControlName: string,
  requiredControlNames: string[]
): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    if (group.get(toggleControlName)?.value !== true) return null;

    const missingControlNames = requiredControlNames.filter((name) =>
      isBlank(group.get(name)?.value)
    );

    return missingControlNames.length
      ? { [REQUIRED_WHEN_ERROR]: missingControlNames }
      : null;
  };
}

function isBlank(value: unknown): boolean {
  return value == null || (typeof value === "string" && value.trim() === "");
}
